import React, { useEffect } from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from 'prop-types';

import './GoogleCaptcha.scss'

function GoogleCaptcha(props){

  const { showError, handleCaptchaChange } = props;

  const handleChange = (tokenResponse) => {
    sessionStorage.setItem(GoogleCaptcha.CAPTCHA_RESPONSE_TOKEN_KEY, tokenResponse)

    handleCaptchaChange(tokenResponse)
  }

  const siteKey = '6LfeEsEZAAAAADk5cPtOlMw2KOSR9buz_hBogE4R';

  let timeout = null;
  const setIdinReCaptcha = (id) => {
    const elementChild = document.getElementById(id);
    const isframeTitle = elementChild && elementChild.getElementsByTagName('iframe')[0] && elementChild.getElementsByTagName('iframe')[0].getAttribute('title') === 'reCAPTCHA';
    if (isframeTitle) {
      elementChild.getElementsByTagName('iframe')[0].id = 'iframeReCaptcha';
    }
  }

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }

    const iframeReCaptcha = document.getElementById('iframeReCaptcha');
    timeout = setTimeout(() => {
      if (iframeReCaptcha === null) {
        setIdinReCaptcha("reCaptcha");
      }
    }, 1000)
    return () => {
      clearTimeout(timeout);
    }
  });

  return (
    <div className="captcha-container">
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={handleChange}
        id="reCaptcha"
      />

      { showError &&
        <span className="captcha-required-message">Please verify that you are human.</span>
      }
    </div>
  )
}

GoogleCaptcha.propTypes = {
  showError: PropTypes.bool.isRequired,
  handleCaptchaChange: PropTypes.func.isRequired
};

export { GoogleCaptcha }

export const CAPTCHA_RESPONSE_TOKEN_KEY = 'CAPTCHA_RESPONSE_TOKEN'